import { useMemo } from 'react';

import { useTranslation } from 'react-i18next';

import type { FeatureRelease } from '../../types';
import type { WhatsNewMenuItemProps } from '../whats-new-menu-item/whats-new-menu-item';

export const getNewsItemTranslationPrefix = (
  newsItemId: string,
  hasAccess: boolean,
) => {
  const access = hasAccess ? 'hasAccess' : 'lacksAccess';
  return `${newsItemId}.${access}`;
};

export const useNewsItems = (featureReleases: FeatureRelease[]) => {
  const { t } = useTranslation('whatsNew');

  const newsItems = useMemo<WhatsNewMenuItemProps[]>(
    () => [
      ...featureReleases
        .map(({ newsItemId, hasAccess, date }) => ({
          translationPrefix: getNewsItemTranslationPrefix(
            newsItemId,
            hasAccess,
          ),
          date,
        }))
        .map(({ translationPrefix, date }) => {
          const { title, description, url } = t(translationPrefix, {
            returnObjects: true,
          }) as { title: string; description: string; url: string };

          return {
            title,
            description,
            url,
            date,
          };
        }),
      {
        title: t('productUpdates.title'),
        description: t('productUpdates.description'),
        url: t('productUpdates.url'),
        date: null,
      },
    ],
    [featureReleases, t],
  );

  return newsItems;
};
